query GetSageGiftAccounts {
  sageGiftAccounts {
    id
    name
    lastSageSyncDate
    sageId
    sageName
    status
    type
    syncTransactions
  }
}
